import { render, staticRenderFns } from "./exam-status-select.vue?vue&type=template&id=86bd2522"
import script from "./exam-status-select.vue?vue&type=script&lang=js"
export * from "./exam-status-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports